import React from "react";
import AssignmentIcon from "@mui/icons-material/Assignment";
import FormValidation from "../../../components/FormValidation/FormValidation";
import formFields from "../../../config/formFields.json";
import { useParams } from "react-router-dom";

const AddProjectDeliverable = ({
  open,
  onClose,
  initialData = null,
  onSubmit,
  milestones = [],
}) => {
  const isEdit = !!initialData?.deliverable_id;
  const initialValues = {
    deliverable_id: initialData?.deliverable_id?.toString() || null,
    milestone_name:initialData?.milestone_name?.toString() || null,
    milestone_id:initialData?.milestone_id?.toString() || null,
    deliverable_code : initialData?.deliverable_code?.toString() || null,
    deliverable_name: initialData?.deliverable_name?.toString() || null,
    deliverable_description: initialData?.deliverable_description?.toString() || null,
    deliverable_start_date: initialData?.deliverable_start_date || null,
    deliverable_end_date: initialData?.deliverable_end_date || null,
    is_active: initialData?.is_active ?? true,
  };

  const getOptionsForField = (fieldName) => {
    switch (fieldName) {
      case "milestone_id":
        return milestones.map((milestone) => ({
          value: milestone.milestone_id?.toString(),
          label: milestone.milestone_name,
        }));
      default:
        return [];
    }
  };

  return (
    <FormValidation
      open={open}
      onClose={onClose}
      initialData={initialValues}
      onSubmit={onSubmit}
      formFields={formFields['projectDeliverable'].basic.fields}
      title="Project Deliverable"
      icon={AssignmentIcon}
      getOptionsForField={getOptionsForField}
      isEdit={isEdit}
      modelWidth={"55vw"}
      moduleName="projectDeliverable"
    />
  );
};

export default AddProjectDeliverable;
